module.exports = __webpack_public_path__ + "static/scale-model-of-bob-dylan-mural-in-minneapolis-minnesota-9232719120ce005acee01ae6d65e7bce.png";